import fileSaver from '../../../../../helpers/download.helper'
import { AxiosService } from './../../../../../services/axios.service'
import { AdminReportsService } from '../../../../../services/admin-reports.service'
import { salesRevenueConstants } from './sales-revenue.constants'
import { Creators as SiteCreators } from '../../../../../ducks/site/site'

const exportData = params => dispatch => {
	dispatch({
		type: salesRevenueConstants.EXPORT_DATA
	})
	dispatch(SiteCreators.showLoading())

	AxiosService.get(`${AdminReportsService.baseURL}/exportar-vendas`, {
		responseType: 'blob',
		params: params
	})
		.then(({ data }) => {
			dispatch(SiteCreators.hideLoading())
			dispatch(downloadData(data))
		})
		.catch(() => dispatch(SiteCreators.hideLoading()))
}

const downloadData = downloadData => async dispatch => {
	dispatch({
		type: salesRevenueConstants.DOWNLOAD_DATA
	})

	await fileSaver(downloadData, 'vendas-e-faturamento.csv')
}

export const salesRevenueActions = { exportData }
